/**
 * @generated SignedSource<<08f9eb24a821ae7e288440ea4c642224>>
 * @relayHash 66b5b097772da9011f598e6bca4f348a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1f36fecc3eefa3ddee455ab966ea901e99ce1aea2ff0f21606e65dd078aabc6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type rovoDevAgentsUserCheckQuery$variables = {
  atlassianAccountId: string;
  cloudId: string;
  isAutodevBetaEnabled: boolean;
};
export type rovoDevAgentsUserCheckQuery$data = {
  readonly devai_rovoDevAgentsUser?: {
    readonly hasProductAccess: boolean | null | undefined;
    readonly isAdmin: boolean | null | undefined;
  };
  readonly jira: {
    readonly isRovoEnabled?: boolean | null | undefined;
  } | null | undefined;
};
export type rovoDevAgentsUserCheckQuery = {
  response: rovoDevAgentsUserCheckQuery$data;
  variables: rovoDevAgentsUserCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "atlassianAccountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAutodevBetaEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "atlassianAccountId",
      "variableName": "atlassianAccountId"
    },
    (v1/*: any*/)
  ],
  "concreteType": "DevAiUser",
  "kind": "LinkedField",
  "name": "devai_rovoDevAgentsUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasProductAccess"
    },
    {
      "kind": "ScalarField",
      "name": "isAdmin"
    }
  ]
},
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "condition": "isAutodevBetaEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v1/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "isRovoEnabled"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rovoDevAgentsUserCheckQuery",
    "selections": [
      {
        "condition": "isAutodevBetaEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v2/*: any*/),
            "action": "THROW",
            "path": "devai_rovoDevAgentsUser"
          }
        ]
      },
      (v3/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rovoDevAgentsUserCheckQuery",
    "selections": [
      {
        "condition": "isAutodevBetaEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v2/*: any*/)
        ]
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "id": "e1f36fecc3eefa3ddee455ab966ea901e99ce1aea2ff0f21606e65dd078aabc6",
    "metadata": {},
    "name": "rovoDevAgentsUserCheckQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ed5ae64fec26e52678f1684923b5c9a6";

export default node;
